// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Card from "../../resources/layout-and-structure/Card.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as InlineText from "../../resources/layout-and-structure/InlineText.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function CatalogProductInformationCard(props) {
  let product = props.product;
  let match = Navigation.useUrl();
  let description = product.description;
  return JsxRuntime.jsx(Card.make, {
    children: JsxRuntime.jsxs(Stack.make, {
      children: [
        JsxRuntime.jsx(TextStyle.make, {
          children: product.name,
          weight: "strong"
        }),
        description !== undefined && description.length > 0 ? JsxRuntime.jsx(TextStyle.make, {
            children: description
          }) : null,
        JsxRuntime.jsxs(InlineText.make, {
          children: [
            JsxRuntime.jsx(TextStyle.make, {
              children: I18n.t("From "),
              variation: "normal"
            }),
            JsxRuntime.jsx(TextStyle.make, {
              children: product.formattedOrigin
            })
          ]
        }),
        JsxRuntime.jsxs(InlineText.make, {
          children: [
            JsxRuntime.jsx(TextStyle.make, {
              children: I18n.t("Default VAT of "),
              variation: "normal"
            }),
            JsxRuntime.jsx(TextStyle.make, {
              children: product.taxValue.toString().replace(".", ",") + " %"
            })
          ]
        })
      ],
      space: "xxsmall"
    }),
    title: I18n.t("Product's information"),
    action: {
      icon: "legacy_edit",
      title: I18n.t("Edit product"),
      href: match.pathname + "/edit"
    }
  });
}

let make = React.memo(CatalogProductInformationCard);

let Config;

export {
  Config,
  make,
}
/* make Not a pure module */
